import { Routes, Route, Navigate } from "react-router-dom";
import { useDynamicFavicon } from "./hooks/useDynamicFavicon";
import { usePageTracking } from "./hooks/usePageTracking";
import DashboardLayout from "./layouts/DashboardLayout";
import AuthLayout from "./layouts/AuthLayout";
import Dashboard from "./pages/Dashboard";
import Login from "./pages/Login";
import Register from "./pages/Register";
import ApiKeys from "./pages/ApiKeys";
import Wallet from "./pages/Wallet";
import Usage from "./pages/Usage";
import Models from "./pages/Models";
import Logs from "./pages/Logs";
import Profile from "./pages/Profile";
import Subscription from "./pages/Subscription";
import Support from "./pages/Support";
import Docs from "./pages/Docs";
import AdminDashboard from "./pages/AdminDashboard";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentFail from "./pages/PaymentFail";
import Terms from "./pages/Terms";

// Admin Pages
import AdminLogin from "./pages/AdminLogin";
import AdminLayout from "./layouts/AdminLayout";
import AdminDashboardPage from "./pages/AdminDashboardPage";
import AdminLogs from "./pages/AdminLogs";
import AdminModels from "./pages/AdminModels";
import AdminUsers from "./pages/AdminUsers";
import AdminRoles from "./pages/AdminRoles";
import AdminSystem from "./pages/AdminSystem";
import AdminSettings from "./pages/AdminSettings";
import AdminTickets from "./pages/AdminTickets";
import AdminExpenses from "./pages/AdminExpenses";
import AdminPlans from "./pages/AdminPlans";
import AdminMessages from "./pages/AdminMessages";
import AdminNotifications from "./pages/AdminNotifications";
import AdminPartners from "./pages/AdminPartners";
import AdminFactors from "./pages/AdminFactors";
import PartnersDashboard from "./pages/PartnersDashboard";

function App() {
  useDynamicFavicon();
  usePageTracking();

  return (
    <Routes>
      {/* Auth Routes */}
      <Route element={<AuthLayout />}>
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Register />} />
        {/* legacy redirect */}
        <Route path="/register" element={<Navigate to="/signup" replace />} />
      </Route>

      {/* Dashboard Routes */}
      <Route element={<DashboardLayout />}>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/api-keys" element={<ApiKeys />} />
        <Route path="/wallet" element={<Wallet />} />
        <Route path="/subscription" element={<Subscription />} />
        <Route path="/usage" element={<Usage />} />
        <Route path="/models" element={<Models />} />
        <Route path="/logs" element={<Logs />} />
        <Route path="/support" element={<Support />} />
        <Route path="/docs" element={<Docs />} />
        <Route path="/partners/dashboard" element={<PartnersDashboard />} />
      </Route>

      {/* Standalone Routes */}
      <Route path="/payment-success" element={<PaymentSuccess />} />
      <Route path="/payment-fail" element={<PaymentFail />} />
      <Route path="/terms" element={<Terms />} />

      {/* Admin Login (no layout) */}
      <Route path="/admin/login" element={<AdminLogin />} />

      {/* Admin Dashboard (legacy - keep for backward compat) */}
      <Route path="/admin" element={<AdminDashboard />} />

      {/* Admin Layout Routes */}
      <Route element={<AdminLayout />}>
        <Route path="/admin/dashboard" element={<AdminDashboardPage />} />
        <Route path="/admin/logs" element={<AdminLogs />} />
        <Route path="/admin/models" element={<AdminModels />} />
        <Route path="/admin/users" element={<AdminUsers />} />
        <Route path="/admin/roles" element={<AdminRoles />} />
        <Route path="/admin/system" element={<AdminSystem />} />
        <Route path="/admin/settings" element={<AdminSettings />} />
        <Route path="/admin/tickets" element={<AdminTickets />} />
        <Route path="/admin/expenses" element={<AdminExpenses />} />
        <Route path="/admin/plans" element={<AdminPlans />} />
        <Route path="/admin/messages" element={<AdminMessages />} />
        <Route path="/admin/notifications" element={<AdminNotifications />} />
        <Route path="/admin/partners" element={<AdminPartners />} />
        <Route path="/admin/factors" element={<AdminFactors />} />
      </Route>

      {/* Redirect */}
      <Route path="/" element={<Navigate to="/dashboard" replace />} />
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

export default App;